import { createUserProfileConfig } from "@/static/userProfileConfig";
import { useAuthStore } from "@/store";
import { useNavigate } from "react-router-dom";
import {
  ActionDropdown,
  ActionDropdownContent,
  ActionDropdownTrigger,
} from "./ActionDropdown";

interface UserProfileDropdownProps {
  userName?: string;
  userEmail?: string;
}

const UserProfileDropdown = ({
  userName = "Super Admin",
  userEmail = "admin@college.edu",
}: UserProfileDropdownProps) => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const userProfileConfig = createUserProfileConfig(navigate, logout);

  // Get initials for avatar
  const initials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <ActionDropdown menuModal={false}>
      <ActionDropdownTrigger
        triggerContent={
          <div className="flex items-center gap-3">
            <div className="bg-primary text-primary-foreground flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold">
              {initials}
            </div>
            <div className="hidden min-w-0 max-w-[150px] flex-col items-start md:flex lg:max-w-[200px]">
              <span className="w-full truncate text-sm font-medium">
                {userName}
              </span>
              <span className="text-muted-foreground w-full truncate text-xs">
                {userEmail}
              </span>
            </div>
          </div>
        }
        buttonVariant="ghost"
        buttonSize="default"
        ariaLabel="User profile menu"
        className={{
          buttonClass: "h-auto px-2 py-1.5",
        }}
      />
      <ActionDropdownContent
        align="end"
        sideOffset={8}
        dropdownShape={userProfileConfig}
        className="w-56"
      />
    </ActionDropdown>
  );
};

export default UserProfileDropdown;
